var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSdcard48Filled = function SvgIconSdcard48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 8.3H21c-.45 0-.88.18-1.2.5l-8 8c-.32.32-.5.75-.5 1.2v16.4c0 2.92 2.38 5.3 5.3 5.3h14.8c2.92 0 5.3-2.38 5.3-5.3V13.6c0-2.92-2.38-5.3-5.3-5.3ZM25.1 21h-3.4v-6h3.4v6Zm6 0h-3.4v-6h3.4v6Z",
    fill: "current"
  })));
};
export default SvgIconSdcard48Filled;